theme.Quantity = (function() {
  const selectors = {
    quantity: '.js--quantity',
  }

  document.addEventListener('click', function (event) {
    // All click events will be handled by this function, so it needs to be as cheap as possible. To check
    // whether this function should be invoked, we're going to check whether the element that was clicked on
    // was the elemnt that we care about. The element that was clicked on is made available at "e.target"
    const element = event.target;

    // Check if it matches our previously defined selector
    if (element.matches(selectors.quantity)) {
      event.preventDefault();
      handleQuantityChange(element);
    }
  });

  function handleQuantityChange(element) {
    const input = element.parentNode.parentNode.querySelector('input');
    const inputVal = parseInt(input.value);
    const incrementBoo = element.getAttribute('js-quantity-selector');
    const increment = incrementBoo.toString();

    if (increment === 'increment') {
      const newVal = inputVal + 1;
      input.value = newVal;
    } else if (inputVal - 1 !== 0) {
      const newVal = inputVal - 1;
      input.value = newVal;
    }
  }

})();
